import { render, staticRenderFns } from "./AdminTaskList.vue?vue&type=template&id=811a031c&scoped=true&"
import script from "./AdminTaskList.vue?vue&type=script&lang=js&"
export * from "./AdminTaskList.vue?vue&type=script&lang=js&"
import style0 from "./AdminTaskList.vue?vue&type=style&index=0&id=811a031c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811a031c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('811a031c')) {
      api.createRecord('811a031c', component.options)
    } else {
      api.reload('811a031c', component.options)
    }
    module.hot.accept("./AdminTaskList.vue?vue&type=template&id=811a031c&scoped=true&", function () {
      api.rerender('811a031c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminTaskList.vue"
export default component.exports